import { DataWizardUploadAttributeTypes } from '../shared-models';

export const attributePlaceholder = (attributeType: DataWizardUploadAttributeTypes): string => {
  let placeholderName: string = attributeType;
  if (attributeType === 'string') {
    placeholderName = 'text';
  }
  return 'Add ' + placeholderName;
};
